import { action, thunk } from 'easy-peasy'

import { FetchStatus } from '@types'

import { ArticleModel, articleService } from '.'

export const article: ArticleModel = {
	paginator: {
		current_page: 1,
		next_page: 0,
		per_page: 10,
		previous_page: 0,
		total_items: 0,
		total_pages: 1
	},
	articles: [],
	status: FetchStatus.LOADING,
	error: {},

	// Actions
	setPaginator: action((state, payload) => {
		state.paginator = payload
	}),
	setArticles: action((state, payload) => {
		state.articles = payload
	}),
	addArticles: action((state, payload) => {
		state.articles = [...state.articles, ...payload]
	}),
	setStatus: action((state, payload) => {
		state.status = payload
	}),
	setError: action((state, payload) => {
		state.error = payload
	}),

	// Thunks
	fetchAllArticle: thunk((action, payload) => {
		action.setStatus(FetchStatus.LOADING)
		articleService
			.getAllArticle(payload)
			.then(({ data, paginator }) => {
				action.setPaginator(paginator)
				action.setArticles(data)
				action.setStatus(FetchStatus.LOADED)
			})
			.catch(e => {
				action.setError(e)
				action.setStatus(FetchStatus.ERROR)
			})
	}),

	fetchMoreArticle: thunk((action, payload) => {
		action.setStatus(FetchStatus.FETCHING_MORE)
		articleService
			.getAllArticle(payload)
			.then(({ data, paginator }) => {
				action.setPaginator(paginator)
				action.addArticles(data)
				action.setStatus(FetchStatus.LOADED)
			})
			.catch(() => {
				action.setStatus(FetchStatus.FETCHING_MORE_ERROR)
				action.setStatus(FetchStatus.LOADED)
			})
	})
}
